;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();const customStyles = {
  placeholder: (base) => ({
    ...base,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '@media only screen and (min-width: 992px)': {
      color: 'transparent',
    },
  }),
  menu: (base) => ({ ...base, zIndex: 1001 }), // z-index must be higher then footer (atm 1000...)
  menuList: (base) => ({ ...base, zIndex: 1001 }), // z-index must be higher then footer (atm 1000...)
};

export default customStyles;
